import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IDPP } from '../models/models'

export class GetDppContentsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'DppEtCetera/getDppContents',
      requesterInfo,
    })
  }

  public async getDppContents(): Promise<IDPP> {
    return await this.getAsync<IDPP>()
  }
}
